/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-no-comment-textnodes */
import React from 'react';
import './style.scss';

interface Props {
  title: string;
  src: string;
}
const pdfPreview: React.FC<Props> = ({ title, src }) => {
  return (
    <div styleName="pdf">
      <div id="pdfDocument" onClick={e => e.stopPropagation()}>
        <iframe styleName="pdf__document" title={title} src={src} />
      </div>
    </div>
  );
};

export default pdfPreview;
